(() => {
	angular.module('main').controller('QuoteViewController', QuoteViewController);

	QuoteViewController.$inject = [
		'$scope',
		'$rootScope',
		'$routeParams',
		'$location',
		'$http',
		'$sce',
		'$timeout',
		'$window',
		'messageService',
		'fileUploadService',
		'jobDataService',
		'timeService',
		'validationService',
		'emailService',
		'userService',
		'leadDataService',
		'newJobsDataService',
		'templateRequestsService',
		'quotesDataService'
	];

	function QuoteViewController(
		$scope,
		$rootScope,
		$routeParams,
		$location,
		$http,
		$sce,
		$timeout,
		$window,
		messageService,
		fileUploadService,
		jobDataService,
		timeService,
		validationService,
		emailService,
		userService,
		leadDataService,
		newJobsDataService,
		templateRequestsService,
		quotesDataService
	) {
		$scope.isJobView = $location.path().includes('/jobs/');
		$scope.isLeadView = $location.path().includes('/leads/');

		$scope.$on('$viewContentLoaded', () => {
			$scope.quoteId = $routeParams.quoteId;
			$scope.jobId = $routeParams.jobId;
			$scope.leadId = $routeParams.leadId;
		});

		$scope.sendMessage = {};
		$scope.emailDataToSave = {};
		let isFirstShow = true;

		clearAttachments();

		$scope.toggleViewCc = function(state) {
			if ($scope.sendMessage && $scope.sendMessage.emailCc) {
				$scope.sendMessage.emailCc = [];
			}

			$scope.showCcField = state !== undefined ? state : !$scope.showCcField;

			if (state === false) {
				isFirstShow = true;
				$scope.sendMessage.emailTo = [];
				clearAttachments();
			}
		};

		$scope.setEmailData = (newData, object, property) => {
			$scope[object][property] = newData;
		};

		// Email methods
		$scope.retrySendMail = function() {
			snCommunicationAdapter.callMethod('updateQuoteViewData');
			emailService.callLastEmailFn();
		};

		$scope.addSubjectVariable = function($event, id) {
			const el = document.getElementById(id);
			$scope.sendMessage.emailSubject = emailService.addSubjectVariable(
				el,
				$event
			);
		};

		$scope.showSendQuote = function(data) {
			$scope.contactEmail = data.contact.email;
			$scope.jobId = data.jobId;
			setCustomToken(data.isFixed ? 'INVOICE_MENU' : 'JOB_MENU');
			if (data.secondaryContact) {
				$scope.secondaryContactEmail = data.secondaryContact.email;
			}

			$scope.sendMessage = {};

			templateRequestsService.getTemplates('all').subscribe(data => {
				if (data) {
					$scope.emails = data;

					if (data.length > 0) {
						$scope.choosenEmail =
							$scope.emails.find(
								item => item.emailTemplateType === 'QUOTE_EMAIL_TEMPLATE'
							) || {};
					}
					$scope.$evalAsync();

					$('#sendQuoteModal')
						.modal('show')
						.on('shown.bs.modal', () => {
							const input = $('#sendQuoteModal').find('input');
							const select = $('#sendQuoteModal').find('select');

							validationService.isModalClosePrevented(input);
							validationService.isModalClosePrevented(select);
						});
				}
			});
		};

		$scope.$watch('choosenEmail', newValue => {
			if (typeof newValue !== 'undefined' && newValue !== '') {
				templateRequestsService
					.getTemplates('full_template', newValue.id)
					.subscribe(data => {
						if (data) {
							$scope.sendMessage.emailSubject = data.subject;
							$scope.sendMessage.emailText = data.text;

							if (data.storedAttachments && data.storedAttachments.length) {
								$scope.attachmentsData = {
									attachments: fileUploadService.convertAttachmentsToShow(
										data.storedAttachments
									)
								};
							} else {
								clearAttachments();
							}

							const rootEmail = $rootScope.primaryContact
								? $rootScope.primaryContact.email || ''
								: '';

							$scope.sendMessage.emailTo = $scope.contactEmail
								? [$scope.contactEmail]
								: [] || rootEmail
									? [rootEmail]
									: [];
							if ($scope.secondaryContactEmail) {
								$scope.sendMessage.emailTo.push($scope.secondaryContactEmail);
							}
							$scope.sendMessage.emailCc = [];

							$scope.sendMessage.emailCc =
								angular.element('#sendQuoteMessageData_emailCc').val() || [];
						}
					});
			}
		});

		function clearAttachments() {
			$scope.attachmentsData = {
				attachments: [],
				filesSize: 0
			};
		}

		// TREBA

		$scope.sendQuote = function() {
			const maxSize = 10; // 10Mb

			if (
				$scope.attachmentsData &&
				$scope.attachmentsData.filesSize > maxSize
			) {
				messageService.showToaster('w_0', 'attachments');
				return false;
			}

			$scope.sendMessage.templateId = $scope.choosenEmail
				? $scope.choosenEmail.id
				: null;
			$scope.sendMessage.emailText = $rootScope.addMaiStyling(
				$scope.sendMessage.emailText
			);

			$scope.sendMessage.jobId = $scope.jobId;
			$scope.sendMessage.quoteId = $routeParams.quoteId;

			const mailData = emailService.prepareEmails($scope.sendMessage);
			if (!emailService.validateMails(mailData)) {
				return;
			}

			$scope.emailDataToSave = Object.assign({}, $scope.sendMessage, mailData);
			delete $scope.emailDataToSave.emailCc;

			const obj2save = angular.copy($scope.emailDataToSave);
			$scope.sendMessage.emailCc = $scope.showCcField ? obj2save.emailCc : '';

			const quoteEmail = $scope.emailDataToSave;

			const formData = new FormData();
			angular.forEach(quoteEmail, (value, key) => {
				console.debug(`key: ${key}  | value: ${value}`);
				formData.append(key, value);
			});

			const filesFromJob = $scope.attachmentsData.attachments.filter(
				file => file.id
			);
			const filesFromComputer = $scope.attachmentsData.attachments.filter(
				file => !file.id
			);

			angular.forEach(filesFromComputer, (value, key) => {
				formData.append(`attachments[${key}]`, value);
			});

			angular.forEach(filesFromJob, (value, key) => {
				formData.append(`storedAttachments[${key}]`, value.id);
			});

			$scope.disableBtnOnSend = true;
			quotesDataService
				.sendQuoteEmailRequest(formData)
				.finally(() => ($scope.disableBtnOnSend = false))
				.subscribe(successSendInvoice, errorSendQuote);
		};

		function successSendInvoice() {
			$scope.$evalAsync();
			$('#sendQuoteModal').modal('hide');
			isFirstShow = true;

			$scope.disableBtnOnSend = false;
			$scope.showCcField = false;

			$scope.$evalAsync();

			clearAttachments();

			if ($scope.isJobView && $rootScope.updateJobView) {
				$rootScope.updateJobView();
			}

			if ($scope.isLeadView && $rootScope.updateLeadView) {
				$rootScope.updateLeadView();
			}

			messageService.showToaster('s_10', 'payments');

			snCommunicationAdapter.callMethod('updateQuoteViewData');
		}

		function errorSendQuote(err) {
			const { status, data, error } = err;
			$scope.disableBtnOnSend = false;
			const { errorMessage, errorTitle } = data;
			const path = $location.path();

			if (error && error.errorCode) {
				messageService.handleError(err);
				return;
			}

			if (status >= 400 && status < 500 && errorMessage) {
				if (status == 423) {
					const limit = $rootScope.isUserTrial ? 50 : 150;
					return messageService.showToaster('e_4', 'generalValidation', limit);
				} else if (errorMessage.includes('Email address inactive')) {
					messageService.showToaster(
						'e_1',
						'generalValidation',
						$scope.sendMessage.emailTo
					);
				} else if (
					errorMessage.includes('Email text should contain a quote link')
				) {
					messageService.showToaster('e_3', 'editQuote');
				} else if (errorMessage.includes('Lead is archived')) {
					messageService.showToaster('e_5', 'lead');
				} else if (errorTitle) {
					messageService.showErrorFromBackend(errorTitle, errorMessage);
				} else if (path.includes('jobs') || path.includes('leads')) {
					messageService.showToaster('e_3', 'editQuote');
				} else {
					messageService.showToaster('e_2', 'general', errorMessage);
				}
			} else {
				messageService.showToaster('e_0', 'general');
			}
		}

		$scope.disableDragDrop = function() {
			return true;
		};

		function setMailData({ primaryContact, secondaryContact, customToken }) {
			$scope.contactEmail = primaryContact.email;
			setCustomToken(customToken);
			if (secondaryContact) {
				$scope.secondaryContactEmail = secondaryContact.email;
			}
		}

		function setCustomToken(token) {
			if (token) {
				$scope.customToken = null;
				requestAnimationFrame(() => ($scope.customToken = token));
			}
		}

		$(document).on('show.bs.modal', '#sendQuoteModal', data => {
			if (isFirstShow) {
				isFirstShow = false;
				if (data.relatedTarget) {
					setMailData(data.relatedTarget);
				}
			}
			$scope.$broadcast('addedFileEvent');
		});
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/quoteViewController.js